export default "__VITE_ASSET__BwXTE8hW__"